import {observable, computed, autorun, toJS, action, runInAction, reaction} from 'mobx';
import moment from 'moment';
import {roundTime, ceilTime, floorTime} from '../utils';
import {TIME_UNIT_DURATION} from '../model/const';


export class VHome {
  constructor(flasher, api, searchForm, searchResults, masterData, organization) {
    this.flasher = flasher;
    this.api = api;
    this.searchForm = searchForm;
    this.searchResults = searchResults;
    this.masterData = masterData;
    this.organization = organization;
    this.reactions = [];
  }

  @observable randomObjects = [];
 
  @action.bound async startOrUpdate({orgId, location, category, subcategory, startDate, duration, timeUnitId, endDate}, router) {
    try {
      this.flasher.setOther('Loading.')
      await Promise.all([,
        this.masterData.cFetch(),
        this.organization.cFetch({
          orgId
        }),
      ]); 

      if(this.organization.isShowingTeasers) {
        this.fetchRandomObjects({
          orgId
        });
      }

      let orgTimeAtomSecs = TIME_UNIT_DURATION[this.organization.refAllotmentTimeUnitId];
      if(!orgTimeAtomSecs) {
        console.error('No length for this organization atom.');
        orgTimeAtomSecs = 15*60;
      }

      await this.searchForm.startOrUpdate({orgId, orgTimeAtomSecs});      

      if(!startDate) {
        startDate = roundTime(moment(), orgTimeAtomSecs);
        router.setParams({searchStartDate: startDate});
      }      
      startDate = floorTime(startDate, orgTimeAtomSecs);
      endDate = ceilTime(endDate, orgTimeAtomSecs);

      // TODO: This is going to be copy pasted to VSearch - REFACTOR.
      runInAction(() => {
        this.searchForm.reset({
          location,
          category,
          subcategory,
          startDate,
          duration,
          timeUnit: timeUnitId,
          endDate,
        })

        if(!this.searchForm.startDate) {
          this.searchForm.changeStartDate(startDate);
        }
        if(!this.searchForm.duration) {
          this.searchForm.changeDuration(1);
          router.setParams({searchDuration: this.searchForm.duration});
        }
        if(!this.searchForm.timeUnit) {
          if(this.organization.timeUnits.length > 0) {
            const tuId = this.organization.timeUnits[0].id;
            this.searchForm.changeTimeUnit(tuId);
          }
          router.setParams({searchTimeUnitId: this.searchForm.timeUnit});
        }
      })

      this.stopReactions();

      this.reactions.push(
        reaction(
          () => {
            const {location, category, subcategory, startDate, endDate, timeUnit, duration} = this.searchForm;
            return {location, category, subcategory, startDate, endDate, timeUnit, duration};
          },
          ({location, category, subcategory, startDate, endDate, timeUnit, duration}) => {
            console.log(startDate)
            router.setParams({
              location,
              category,
              subcategory,
              searchStartDate: startDate,
              searchEndDate: endDate,
              searchTimeUnitId: timeUnit,
              searchDuration: duration,
            })
          },
          {
            compareStructural: true,
            fireImmediately: true,
          }           
        )
      )

    }
    finally {
      this.flasher.setOther()      
    }
  }

  @action.bound stop() {
    this.searchForm.stop();
    this.stopReactions();
  }

  @action.bound stopReactions() {
    this.reactions.forEach(ar => ar());
    this.reactions = [];
  }  

  async fetchRandomObjects({orgId}) {
    this.randomObjects = await this.searchResults.cFetchRandomObjects({
      orgId,
      count: 3, 
    });
  }


} 


// WEBPACK FOOTER //
// ./src/view/VHome.js